// extracted by mini-css-extract-plugin
export var progressBar = "_ja-0";
export var progressBarInner = "_ja-1";